export default __webpack_public_path__ + "static/visu-66ce2c79ef422655f12062dba7c3050e.jpg";